import { lazy } from 'react';

import { PATHS } from './constants';

const PaymentSuccess = lazy(() => import('./PaymentSuccess'));
const PaymentPending = lazy(() => import('./PaymentPending'));
const PaymentFailed = lazy(() => import('./PaymentFailed'));

export const PaymentPagesConfig = {
  settings: {
    layout: {
      config: {
        navbar: { display: false },
        toolbar: { display: false },
        footer: { display: false },
        leftSidePanel: { display: false },
        rightSidePanel: { display: false },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: PATHS.PAYMENT_SUCCESS,
      element: <PaymentSuccess />,
    },
    {
      path: PATHS.PAYMENT_PENDING,
      element: <PaymentPending />,
    },
    {
      path: PATHS.PAYMENT_FAILED,
      element: <PaymentFailed />,
    },
  ],
};
